import React from 'react';

export function Button({
  href,
  label,
  variant = 'primary',
  className = '',
  ariaLabel,
  children,
  ...rest
}) {
  const classes = ['button', `button--${variant}`, className].filter(Boolean).join(' ');
  const content = children || <span>{label}</span>;
  const aria = ariaLabel || label;

  if (href == null) {
    return (
      <button type="button" className={classes} aria-label={aria} {...rest}>
        {content}
      </button>
    );
  }

  return (
    <a className={classes} href={href} aria-label={aria} {...rest}>
      {content}
    </a>
  );
}
